(function (Drupal, window, document, undefined) {
  'use strict';

  Drupal.behaviors.strategicCardsEqualHeight = {
    attach: function (context) {
      var fields = context.querySelectorAll('.field--name-field-strategic-card');

      fields.forEach(function (field) {
        if (field.dataset.equalHeightInitialized) return;
        field.dataset.equalHeightInitialized = 'true';

        function items() {
          return Array.prototype.filter.call(field.children, function (child) {
            return child.classList.contains('field__item');
          });
        }

        function equalize() {
          var cards = items();

          cards.forEach(function (item) {
            item.style.height = '';
          });

          if (window.innerWidth <= 575) {
            return;
          }

          var max = 0;
          cards.forEach(function (item) {
            max = Math.max(max, item.offsetHeight);
          });

          cards.forEach(function (item) {
            item.style.height = max + 'px';
          });
        }

        equalize();
        window.addEventListener('load', equalize);

        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(equalize, 200);
        });
      });
    }
  };

  Drupal.behaviors.strategicCardsReveal = {
    attach: function (context) {
      var items = context.querySelectorAll('.scc-reveal');
      if (!items.length) {
        return;
      }

      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('scc-reveal--visible');
        });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scc-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      items.forEach(function (item) {
        if (item.dataset.revealInitialized) {
          return;
        }
        item.dataset.revealInitialized = 'true';
        observer.observe(item);
      });
    }
  };

})(Drupal, window, document);
